import { MessageKeys } from "constants/messages/i8ln/EnglishMessages";
import { Options } from "constants/options/option";
import { FilterFieldType } from "interfaces/filter/filterColumn";

export const DOCUMENTS_MONTHS_VALUES = (): Options[] => {
  const months = ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"];
  return months.map((month) => {
    return {
      id: month,
      name: month,
    };
  });
};

export const DOCUMENTS_PAST_MONTH = () => {
  const currentMonth = new Date().getUTCMonth();
  // if current month = 0 (January), pre-select December (past month)
  const pastMonth = currentMonth < 1 ? 12 : currentMonth;
  const formattedMonth = pastMonth.toString().length < 2 ? `0${pastMonth.toString()}` : pastMonth.toString();
  return {
    id: formattedMonth,
    name: formattedMonth,
  };
};

export const DOCUMENTS_YEARS_VALUES = (): Options[] => {
  const minYear = 2023;
  const today = new Date();
  let currentYear = today.getUTCFullYear();
  // if Januray, pre-select last year
  if (today.getUTCMonth() === 0) {
    currentYear -= 1;
  }
  const numberOfYears = currentYear - minYear + 1;
  return Array.from({ length: numberOfYears }, (_, index) => {
    const years = (minYear + index).toString();
    return {
      id: years,
      name: years,
    };
  });
};

export interface DocumentsFilterLine {
  id: string;
  label: MessageKeys;
  type?: FilterFieldType.MULTISELECT;
  multiple?: boolean;
  translateLabel?: boolean;
  displayCheckboxes?: boolean;
}

export interface DocumentsFilterLines {
  [key: string]: DocumentsFilterLine;
}

export const DOCUMENTS_FILTERS: DocumentsFilterLines = {
  SETTLEMENT_YEAR: {
    id: "settlementYears",
    label: "doc_settlement_year",
    type: FilterFieldType.MULTISELECT,
    translateLabel: false,
    multiple: false,
    displayCheckboxes: false,
  },
  SETTLEMENT_MONTH: {
    id: "settlementMonths",
    label: "doc_settlement_month",
    type: FilterFieldType.MULTISELECT,
    translateLabel: false,
    multiple: false,
    displayCheckboxes: false,
  },
};
